import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { isAuthenticated, useAuthFailureStore, useMe } from "@/lib/auth";
import { GlobalSearchPaletteHost } from "@/modules/search";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { Spinner } from "./Spinner";

export function ProtectedRoute() {
  const location = useLocation();
  const me = useMe();
  const redirectFlag = useAuthFailureStore((s) => s.redirectToLogin);
  const setRedirect = useAuthFailureStore((s) => s.setRedirect);

  useEffect(() => {
    if (redirectFlag) {
      // Consume the flag on the way out so a subsequent successful login
      // doesn't immediately bounce again.
      setRedirect(false);
    }
  }, [redirectFlag, setRedirect]);

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (me.isLoading) return <Spinner fullscreen label="Loading…" />;
  if (me.isError) return <Navigate to="/login" replace />;
  return (
    <>
      <ImpersonationBanner />
      <Outlet />
      {/* Phase 1B-J — global Cmd/Ctrl+K command palette. Lives inside
       *   the ProtectedRoute outlet so it's only summoned when the
       *   operator is authenticated (the API would 401 anyway). */}
      <GlobalSearchPaletteHost />
    </>
  );
}